<template>
    <div class="hello">
      <ul class="sidebar">
        <li><router-link to="/products"><p><i><img src="../../assets/icons/catalog.png" alt=""></i>产品目录</p></router-link></li>
        <!--<li><a href="https://service.web2cad.co.jp/pcom/maker_login_qa.php?Maker=KANA&languag</a>e=zh" target="_blank"><p><i><img src="../../assets/icons/data.png" alt=""></i>CAD 数据</p></a></li>-->
        <li><a href="https://service.web2cad.co.jp/pcom/maker_login.php?Maker=KANA&language=zh" target="_blank"><p><i><img src="../../assets/icons/data.png" alt=""></i>CAD 数据</p></a></li>
        <li><a href="http://www.kana.net.cn/book_20_5801_all/book/index.html#target/page_no=1" target="_blank"><p><i><img src="../../assets/icons/file.png" alt=""></i>文档数据</p></a></li>
        <li><router-link to="/special"><p><i><img src="../../assets/icons/special.png" alt=""></i>特注品事例</p></router-link></li>
        <li><a href="https://pianshanshop.1688.com" target="_blank"><p><i><img src="../../assets/icons/shop2.png" alt=""></i>片山1688网店</p></a></li>
      </ul>
    </div>
</template>

<script>
  export default {
    name: 'hello',
    components: {
    },
    data () {
      return {
        msg: 'hello'
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss" scoped>
 .sidebar{
   width: 360px;
   /*float: right;*/
   overflow: hidden;
   li{
     height: 63px;
     background: -webkit-linear-gradient(#ffffff,#e6e7e7);
     background: -o-linear-gradient(#ffffff,#e6e7e7);
     background: -moz-linear-gradient(#ffffff,#e6e7e7);
     background: linear-gradient(#ffffff,#e6e7e7);
     border: solid 1px #e6e7e7;
     margin-bottom: 5px;
     line-height: 63px;
     font-weight: bold;
     font-size: 24px;
     a{
       color: #333333;
     }
     p{
       width: auto;
       line-height: 63px;
       margin: auto;
       margin-left: 25%;
       text-align: left;
       vertical-align: middle;
       i{
         display: inline-block;
         width: 40px;
         height: 40px;
         vertical-align: middle;
       }
     }
   }
 }
 @media only screen and (max-width: 767px){
   .sidebar{
     width: 100%;
     margin: 10px auto;
     display: flex;
     li{
       width: 80px;
       height: 70px;
       border-radius: 50%;
       margin: auto;
       a{
        display: flex;
        align-items: center;
        height: 100%;
       }
       p{
         width: 100%;
         line-height: initial;
         font-size: 15px;
         text-align: center;
         margin-left: 0;
         i{
          display: none;
         }
       }
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/home/SideBar.vue